import React, { useEffect, useState } from "react";
import { CheckIcon, KeyIcon, XCircleIcon } from "@heroicons/react/solid";
import { Col, Row, Card, Button, Modal, FormCheck, ToastContainer, InputGroup, Form } from 'react-bootstrap';
import Select from 'react-select';
import CopyToClipboard from "react-copy-to-clipboard";
import { useCheckUserDetailsMutation, useUserDropDownMutation, useGetEUforEAMutation, useGetRoutesOfEAMutation, useEditSmsAccountMutation } from "Services/services";
import { CiEdit } from "react-icons/ci";
import { Toast } from 'react-bootstrap';

import { SMSRegistrationListTable } from "./Tables";
import { MdOutlineAutoMode } from "react-icons/md";
import TableWrapper from 'components/TableWrapper';

export const GeneralInfoForm = () => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');

    // Get the usertype from localStorage
  const loggedUserData = localStorage.getItem('TOKEN');
  const userObject = JSON.parse(loggedUserData);
  const loggedUserType = userObject.user_type;

  const [editDetails, setEditDetails] = useState({});
  const [previewDetails, setPreviewDetails] = useState({});
  const [isValidated, setIsValidated] = useState(false);
  const [showEdit, setShowEdit] = useState(false)
  const [showEditDefault, setShowEditDefault] = useState(false);

  const [copied, setCopied] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');

  const [userDetailUpdates] = useEditSmsAccountMutation();
  const [verify] = useCheckUserDetailsMutation();
  const [isEditingPassword, setIsEditingPassword] = useState(false);
  const [isEditPassword, setIsEditPassword] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);


  const [users, setUsers] = useState([]);
  const [entadmin, setEntAdmin] = useState(null);
  const [entUserOptions, setEntUserOptions] = useState([]);
  const [routesOfEnt, setRoutesOfEnt] = useState([]);
  const dltTypeOptions = [
    { value: "", label: "None" },
    { value: "Default", label: "Default" },
    { value: "Whitelisted", label: "Whitelisted" },
  ];

  const fieldLabels = {
    enterprise_admin_name: "Enterprise Name",
    enterprise_user_name: "Enterprise User Name",
    system_id: "System ID",
    department_name: "Department Name",
    Route: "Route",
    throughput: "Throughput",
  };

  const requiredFields = [
    "enterprise_admin_name",
    "enterprise_user_name",
    "system_id",
    "department_name",
    "Route",
    "throughput",
  ];

  const missingFields = requiredFields.filter((field) => {
    const value = editDetails[field];
    return value === null || value === undefined || String(value).trim() === "";
  });

  useEffect(() => {
    setIsValidated(missingFields.length === 0);
    // eslint-disable-next-line
  }, [editDetails]);

  useEffect(() => {
    // if (loggedUserType !== "enterprise") {
      fetchUserDropdown();
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEdit = (userDetails) => {
    setEditDetails(userDetails);
    setShowEdit(true);
  };

  useEffect(() => {
    if (editDetails.enterprise_admin_name) {
      const ent = users.find(u=>u.label===editDetails.enterprise_admin_name).value;
      setEntAdmin(ent);
    }
  }, [editDetails.enterprise_admin_name, users]);

  useEffect(() => {
    if (editDetails.enterprise_admin_name || loggedUserType === "enterprise") {
      fetchEUOfEA(entadmin);
      fetchRoutesOfEA(entadmin);
    }
    // eslint-disable-next-line
  }, [entadmin, loggedUserType]);
  
  const [userDropDown] = useUserDropDownMutation();
  const fetchUserDropdown = async () => {
    userDropDown({ user_type: "4" })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          const userOptions = response.data.data.user_details.map((user) => ({
            value: user.id,
            label: user.name,
          }));
          setUsers(userOptions);
        } else {
          setUsers([]);
          console.error("Failed to fetch user data");
        }
      })
      .catch((error) => {
        setUsers([]);
        console.error("Error fetching user data", error);
      });
  };

  const [fetchEU] = useGetEUforEAMutation();
  const fetchEUOfEA = async (entadmin) => {
    try {
      const response = await fetchEU({
        user_id: loggedUserType === "enterprise" ? userObject.id : entadmin,
      });
      if (response?.data?.statusCode === 200) {
        const options = response.data.data.dropDownData.map((user) => ({
          value: user.id,
          label: user.user_name,
        }));
        setEntUserOptions(options);
      } else {
        setEntUserOptions([]);
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      setEntUserOptions([]);
      console.error("Error fetching user data", error);
    }
  };

  const [routesOfEA] = useGetRoutesOfEAMutation();
  const fetchRoutesOfEA = async (entadmin) => {
    try {
      const response = await routesOfEA({
        user_id: loggedUserType === "enterprise" ? userObject.id : entadmin,
      });
      if (response?.data?.statusCode === 200) {
        const options = response.data.data.finalRouteData.map((user) => ({
          value: user.id,
          label: user.route_name,
        }));
        setRoutesOfEnt(options);
      } else {
        setRoutesOfEnt([]);
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      setRoutesOfEnt([]);
      console.error("Error fetching user data", error);
    }
  };

  const [passwordError, setPasswordError] = useState("");
  const handlePasswordChange = (e) => {
    const newValue = e.target.value;
    // Limit length and allow valid characters
    if (newValue.length <= 32) {
    setEditDetails({...editDetails, "password": newValue});

      // Validate live feedback
      const isValid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^])[A-Za-z\d@$!%*?&#^]{8,32}$/.test(newValue);
      setPasswordError(!isValid);
    }
    setEditDetails({...editDetails, "password": newValue});
};

const [isVerifiedUsername, setisVerifiedUsername] = useState(null);

const verifyUsername = (e) => {
  const username = e.target.value;
  setEditDetails({ ...editDetails, "system_id": username })

  const regex = /^(?=.*[a-zA-Z].*[a-zA-Z])[a-zA-Z0-9_]+$/;

  if (username.length >= 3 && username.length <= 12 && regex.test(username)) {
    const postData = { data: username };
    verify(postData)
      .then((success) => {
        if (success?.data?.statusCode === 200) {
          setisVerifiedUsername(true);
        } else if (success?.data?.statusCode > 300) {
          setisVerifiedUsername(false);
          console.error("Verification failed");
        }
      })
      .catch((error) => {
        setisVerifiedUsername(false);
        console.error("Verification failed", error);
      });
  } else {
    setisVerifiedUsername(false);
  }
};

  const generatePassword = () => {
    const length = 12;
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numbers = "0123456789";
    const symbols = "@$!%*?&#^";
  
    const all = lower + upper + numbers + symbols;
  
    let newPassword = "";
    newPassword += lower[Math.floor(Math.random() * lower.length)];
    newPassword += upper[Math.floor(Math.random() * upper.length)];
    newPassword += numbers[Math.floor(Math.random() * numbers.length)];
    newPassword += symbols[Math.floor(Math.random() * symbols.length)];
  
    for (let i = 4; i < length; i++) {
      newPassword += all[Math.floor(Math.random() * all.length)];
    }
  
    // Shuffle newPassword to remove predictable pattern
    newPassword = newPassword
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("");
  
    setEditDetails({...editDetails, "password": newPassword});
    setPasswordError(false);
  };

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const handleClose = () => {
    setShowEditDefault(false);
    setShowEdit(false);
  }

  const handleCloseBack = () => {
    setShowEditDefault(false);
    setShowEdit(true);
  }


  const handleEditSubmit = (e) => {
    e.preventDefault();

    const payload = {
      system_id: editDetails.system_id || "",
      password: editDetails.password || "",  
      throughput: editDetails.throughput || "",
      connect_allow_ip: editDetails.connect_allow_ip || "",
      dlt: editDetails.dlt || "",
      department_name: editDetails.department_name || "",
      route: editDetails.Route || "",

      ...(loggedUserType !== "enterprise" && {
        enterprise_admin_name: editDetails.enterprise_admin_name || "",
      }),
      enterprise_user_name: editDetails.enterprise_user_name || "",
    };

    setPreviewDetails(payload);
    setShowEdit(false);
    setShowEditDefault(true);
  }

  const submitEditForm = (e) => {
    e.preventDefault();

    // to send id in vendor
    const entUserId = entUserOptions.find(u => String(u.label) === String(editDetails.enterprise_user_name)).value;

    const editedPostData = {
      ...previewDetails,
    user_id: entUserId, 
    default_smsc: "",
    default_cost: "0.0",
    enable_prepaid_billing: 1,
    credit: 0,
    callback_url: "",
    callback_method: "GET",
    callback_body: "",
    simulate: 0,
    simulate_deliver_every: 0,
    simulate_temporary_failure_every: 0,
    simulate_permanent_failure_every: 0,
    simulate_mo_every: 0,
    max_binds: 10,
    reroute: 0,
    spam: "00",
    coordinator: "0",
    user: "userchain",
    // user_id: loggedUserType === "enterprise" ? userObject.id : entadmin,
    hlr_lookup: 0,
    active: "ACTIVE",
    sender_type: "ANY",
    channel: "SMPP",
    dlt_cost: "0.0",
    refund_amount: "0.0",
    parent: userObject.user_chain,
    created_by: userObject.id,
    smsc_type: "international", //domestic||international
    receiver: "00",
    senderid: "00",
    contentid: "00",

    };

    userDetailUpdates(editedPostData)
    .then((res) => {
      // If using RTK Query style response
      if (res.error) {
        console.log("error", res.error);
        setToastMessage(res.error?.data?.message || "Error Updating User details!");
        setToastVariant("danger");
      } else if (res.data?.statusCode === 200) {
        setShowEdit(false);
        setShowEditDefault(false);
        setEditDetails([]);
        setRefreshTable(!refreshTable);
        setToastMessage(res.data?.message || "User details Updated!");
        setToastVariant("success");
      } else {
        setToastMessage(res.data?.message || "Error Updating User details!");
        setToastVariant("danger");
      }
    })
    .catch((error) => {
      console.log("catch error", error);
      setToastMessage(error?.data?.message || "Error Updating User details!");
      setToastVariant("danger");
    })
    .finally(() => {
      setShowToast(true);
    });  
  };


  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>


      <div>
        <Modal backdrop="static" size="lg" keyboard={false} as={Modal.Dialog} centered show={showEdit} onHide={handleClose}>
          <Modal.Header>
            <Modal.Title className="h6">Edit User Details</Modal.Title>
            <Button variant="close" aria-label="Close" onClick={handleClose} />
          </Modal.Header>
            <Card className="mb-2 mt-2 border-0">
              <Row>
                <Col md={12}>
                  <TableWrapper>
                    <tbody>
                      {(loggedUserType !== "enterprise") && <tr>
                        <td className="border-0">Enterprise Name</td>
                        <td className="border-0">
                           <Select
                              options={users}
                              placeholder="Select User"
                              className="mb-0"
                              isSearchable={true}
                              value={users.find(u => u.label === editDetails.enterprise_admin_name) || null}
                              onChange={(selectedOption) => {
                                setEditDetails({ ...editDetails, enterprise_admin_name: selectedOption?.label });
                              }}
                               // Ensure the dropdown appears over the card
                               menuPortalTarget={document.body} // Attach the dropdown to the body
                               styles={{
                                 menuPortal: (base) => ({
                                   ...base,
                                   zIndex: 9999,
                                 }), // High z-index
                               }}
                            />
                        </td>
                      </tr>}
                      <tr>
                        <td className="border-0">Enterprise User Name</td>
                        <td className="border-0">
                        <Select
                          options={entUserOptions}
                          placeholder="Select User"
                          className="mb-0"
                          isSearchable={true}
                          value={entUserOptions.find(u => u.label === editDetails.enterprise_user_name) || null}
                          onChange={(selectedOption) => {
                            setEditDetails({ ...editDetails, enterprise_user_name: selectedOption?.label });
                          }}
                            // Ensure the dropdown appears over the card
                            menuPortalTarget={document.body} // Attach the dropdown to the body
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }), // High z-index
                            }}
                        />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">System ID</td>
                        <td className="border-0">
                        <InputGroup>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Enter System ID"
                          value={editDetails.system_id || ""}
                          onChange={verifyUsername}
                          pattern="^[a-zA-Z0-9]+$"
                          title="This must be alphanumeric with 2-8 characters, no spaces."
                          autoComplete="new-username"
                        />
                    {isVerifiedUsername && (
                      <InputGroup.Text title="System ID is available and unique">
                        <CheckIcon width={20} className="text-success" />
                      </InputGroup.Text>
                    )}
                    {isVerifiedUsername === false && (
                      <InputGroup.Text title="System ID is not available or unique">
                        <XCircleIcon width={20} className="text-danger"/>
                      </InputGroup.Text>
                    )}
                    </InputGroup>
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Department Name</td>
                        <td className="border-0">
                          <input
                            type="text"
                            value={editDetails.department_name || ""}
                            onChange={(e) => setEditDetails({ ...editDetails, department_name: e.target.value })}
                            className="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Route</td>
                        <td className="border-0">
                        <Select
                          options={routesOfEnt}
                          placeholder="Select Route"
                          className="mb-0"
                          value={routesOfEnt.find(u => u.label === editDetails.Route) || null}
                          onChange={(selectedOption) => {
                            setEditDetails({ ...editDetails, Route: selectedOption?.label });
                          }}
                            // Ensure the dropdown appears over the card
                            menuPortalTarget={document.body} // Attach the dropdown to the body
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }), // High z-index
                            }}
                        />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Throughput</td>
                        <td className="border-0">
                          <input
                            type="text"
                            value={editDetails.throughput || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (/^\d*$/.test(val)) {
                                setEditDetails({ ...editDetails, throughput: val });
                              }
                            }}
                            maxLength={4}
                            title="TPS must be a 1-4 digit positive number"
                            className="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Allowed IP</td>
                        <td className="border-0">
                          <div className="d-flex gap-1">
                            {[0, 1, 2, 3].map((index) => (
                              <input
                                key={index}
                                type="text"
                                value={(() => {
                                  const ipParts = editDetails.connect_allow_ip ? editDetails.connect_allow_ip.split('.') : ["", "", "", ""];
                                  return ipParts[index] || "";
                                })()}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (val === "" || (/^\d{1,3}$/.test(val) && +val <= 255)) {
                                    const currentParts = editDetails.connect_allow_ip ? editDetails.connect_allow_ip.split('.') : ["", "", "", ""];
                                    const newParts = [...currentParts];
                                    newParts[index] = val;
                                    setEditDetails({ ...editDetails, connect_allow_ip: newParts.join('.') });
                                  }
                                }}
                                style={{ width: "60px", textAlign: "center" }}
                                className="form-control"
                                maxLength={3}
                                placeholder="0"
                              />
                            ))}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">DLT</td>
                        <td className="border-0">
                        <Select
                    options={dltTypeOptions}
                    placeholder="Select DLT-Type"
                    className="mb-0"
                    isSearchable={true}
                    value={dltTypeOptions.find(u => u.label === editDetails.dlt) || null}
                    onChange={(val) => {
                      setEditDetails({ ...editDetails, dlt: val?.label });
                      // setValidationError((prev) => ({
                      //   ...prev,
                      //   dltType: false,
                      // }));
                    }}
                      // Ensure the dropdown appears over the card
                      menuPortalTarget={document.body} // Attach the dropdown to the body
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }), // High z-index
                      }}
                  />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Password</td>
                        <td className="border-0">
                          <div className="input-group">
                            {isEditPassword ? (
                              <>
                                <span className="input-group-text">
                                  <KeyIcon width={20} />
                                </span>
                                  <input
                                  required
                                  type="password"
                                  maxLength={8}
                                  placeholder="Password"
                                  autoComplete="new-password"
                                  value={editDetails.password || ""}
                                  title="Password must be 8-32 characters, include uppercase, lowercase, number, and special character."
                                  onChange={handlePasswordChange}
                                  className={`form-control ${passwordError ? "is-invalid" : ""}`}
                                />
                                <span
                                  className="input-group-text"
                                  onClick={generatePassword}
                                  style={{ cursor: 'pointer' }}
                                  title="Auto-generate password"
                                >
                                  <MdOutlineAutoMode size={20} />
                                </span>
                                {passwordError && <div className="invalid-feedback">{passwordError}</div>}
                              </>
                            ) : (
                              <Button variant="light" onClick={() => setIsEditPassword(!isEditPassword)}>
                                <CiEdit size={25} />
                              </Button>
                            )}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </TableWrapper>
                  {missingFields.length > 0 && (
                    <div className="mt-2">
                      <div className="fw-bold mb-1">Please fill the following required fields:</div>
                      <ul className="mb-0">
                        {missingFields.map((f) => (
                          <li key={f}>{fieldLabels[f] || f}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </Col>
              </Row>
            </Card>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleEditSubmit} disabled={!isValidated}>
              Preview
            </Button>
          </Modal.Footer>
        </Modal>


        {/* edit password */}
        <Modal backdrop="static" keyboard={false} as={Modal.Dialog} centered show={isEditingPassword && !isEditPassword} onHide={handleClose}>
          <Modal.Header>
            <Modal.Title className="h6">Edit Password Confirmation</Modal.Title>
            <Button variant="close" aria-label="Close" onClick={() => setIsEditingPassword(!isEditingPassword)} />
          </Modal.Header>
          <Modal.Body>
            <p>Once confirmed, you will be required to update your password.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => {
              setIsEditPassword(!isEditPassword);
              setEditDetails((prevDetails) => ({
                ...prevDetails,
                password: ""
              }));
            }}>
              Confirm
            </Button>
            <Button variant="link" className="text-gray ms-auto" onClick={() => setIsEditingPassword(!isEditingPassword)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>


        {/* edited details preview */}
        <Modal backdrop="static" keyboard={false} as={Modal.Dialog} centered show={showEditDefault} onHide={handleCloseBack}>
          <Modal.Header>
            <Modal.Title className="h6">Editted User Detail Preview</Modal.Title>
            <Button variant="close" aria-label="Close" onClick={handleCloseBack} />
          </Modal.Header>
          <Modal.Body>
            <Card className="mb-2 mt-2">
              <Row>
                <Col md={10}>
                  <TableWrapper>
                    <tbody>
                     { (loggedUserType !== "enterprise") && <tr>
                        <td className="border-0">Enterprise Name</td>
                        <td className="border-0 " title={editDetails.enterprise_admin_name}>
                          {editDetails.enterprise_admin_name}
                        </td>
                      </tr>}
                      <tr>
                        <td className="border-0">Enterprise User Name</td>
                        <td className="border-0 " title={editDetails.enterprise_user_name}>
                          {editDetails.enterprise_user_name}
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">System ID</td>
                        <td className="border-0 " title={editDetails.system_id}>
                          {editDetails.system_id}
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Department Name</td>
                        <td className="border-0 " title={editDetails.department_name}>
                          {editDetails.department_name}
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Route</td>
                        <td className="border-0 " title={editDetails.Route}>
                          {editDetails.Route}
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Channel</td>
                        <td className="border-0 " title={editDetails.channel}>
                          {editDetails.channel}
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Throughput</td>
                        <td className="border-0 " title={editDetails.throughput}>
                          {editDetails.throughput}
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">IP Address</td>
                        <td className="border-0 " title={editDetails.connect_allow_ip}>
                          {editDetails.connect_allow_ip}
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">DLT</td>
                        <td className="border-0 " title={editDetails.dlt}>
                          {editDetails.dlt}
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Password</td>
                        <td className="border-0 " title={editDetails.password}>
                        *********
                        </td>
                      </tr>
                      
                    </tbody>
                  </TableWrapper>
                </Col>
                <Col md={2} className="d-flex align-items-start">
                    <div>
                      {copied ? (
                        <Button size="sm" variant="success" className="copy-code-button">
                          Copied
                        </Button>
                      ) : (
                        <CopyToClipboard
                          text={Object.entries(previewDetails)
                            .map(([key, value]) => `${key}: ${value}`)
                            .join("\n")}
                          onCopy={handleCopy}
                        >
                          <Button size="sm" variant="secondary" className="copy-code-button">
                            Copy
                          </Button>
                        </CopyToClipboard>
                      )}
                    </div>
                </Col>
              </Row>
            </Card>
            <Card className="mb-2 mt-3 mx-0">
              <Row>
                <Col md={12}>
                    <b>Share Details:</b>
                    <FormCheck type="switch" className="mt-2">
                      <FormCheck.Input
                        type="checkbox"
                        id="emailSwitch"
                        checked={selectedOption === 'email'}
                        onChange={() => setSelectedOption('email')}
                      />
                      <FormCheck.Label htmlFor="emailSwitch" style={{ marginLeft: '8px' }}>
                        Email ID
                      </FormCheck.Label>
                    </FormCheck>
                    <FormCheck type="switch" className="mt-2">
                      <FormCheck.Input
                        type="checkbox"
                        id="phoneSwitch"
                        checked={selectedOption === 'phone'}
                        onChange={() => setSelectedOption('phone')}
                      />
                      <FormCheck.Label htmlFor="phoneSwitch" style={{ marginLeft: '8px' }}>
                        Phone Number
                      </FormCheck.Label>
                    </FormCheck>
                    <FormCheck type="switch" className="mt-2">
                      <FormCheck.Input
                        type="checkbox"
                        id="bothSwitch"
                        checked={selectedOption === 'both'}
                        onChange={() => setSelectedOption('both')}
                      />
                      <FormCheck.Label htmlFor="bothSwitch" style={{ marginLeft: '8px' }}>
                        Both
                      </FormCheck.Label>
                    </FormCheck>
                    <FormCheck type="switch" className="mt-2">
                      <FormCheck.Input
                        type="checkbox"
                        id="noneSwitch"
                        checked={selectedOption === ''}
                        onChange={() => setSelectedOption('')}
                      />
                      <FormCheck.Label htmlFor="noneSwitch" style={{ marginLeft: '8px' }}>
                        None
                      </FormCheck.Label>
                    </FormCheck>
                </Col>
              </Row>
            </Card>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={(e) => submitEditForm(e)} className="ms-auto">
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      
      <SMSRegistrationListTable key={refreshTable} handleEdit={handleEdit} />
    </>
  );
};
